import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, TextField, Typography } from "@mui/material";
import { getsRol, getsAcceso, getsRolAcceso } from "../../services/seguridadService";
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Listado de accesos: cada acceso es una accion del sistema, identificada por su
// codigo pagina.accion, que es el que usan las pantallas y la API. Un acceso se
// concede a un rol, no a un usuario.
const Access = () => {
    const { isReadOnly } = useMantenimiento("rol");

    const [filters, setFilters] = useState({ descripcion: "" });
    const [accesos, setAccesos] = useState([]);
    const [rolesPorAcceso, setRolesPorAcceso] = useState({});
    const [cargando, setCargando] = useState(true);

    const fetchResults = useCallback(async () => {
        setCargando(true);

        const data = await getsAcceso().catch((err) => { console.log("Err: ", err) });

        setAccesos(data || []);

        // Que roles tienen cada acceso.
        const listaRoles = await getsRol().catch((err) => { console.log("Err: ", err) });
        const porAcceso = {};

        for (const rol of (listaRoles || [])) {
            const delRol = await getsRolAcceso(rol.id).catch((err) => { console.log("Err: ", err) });

            for (const item of (delRol || [])) {
                if (item.idEstado != 2) continue;

                porAcceso[item.idAcceso] = (porAcceso[item.idAcceso] || []).concat(rol.nombre);
            }
        }

        setRolesPorAcceso(porAcceso);
        setCargando(false);
    }, [])

    useEffect(() => {
        fetchResults();
    }, [])

    const columns = [
        { field: 'nombres', headerName: 'Codigo', width: 200, sortable: false, headerAlign: 'left' },
        { field: 'descripcion', headerName: 'Accion', width: 220, sortable: false, headerAlign: 'left' },
        { field: 'roles', headerName: 'Roles con el acceso', width: 260, sortable: false, headerAlign: 'left'
            , valueGetter: (value, row) => (rolesPorAcceso[row.id] || []).join(", ")
        },
        { field: 'estado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center'
            , valueGetter: (value, row) => row.idEstado == 2 ? "Activo" : "Inactivo"
        },
    ];

    const resultados = accesos.filter((row) => {
        if (filters.descripcion == "") return true;

        return row.nombres.toLowerCase().includes(filters.descripcion.toLower())
            || (row.descripcion || "").toLowerCase().includes(filters.descripcion.toLower());
    });

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Accesos
                    </Typography>
                </Grid>
                <Grid container spacing={1} alignItems={"center"} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={8} sm={4}>
                        <TextField
                            name="descripcion"
                            label="Codigo o accion"
                            value={filters.descripcion}
                            fullWidth
                            onChange={(event) => setFilters({ ...filters, descripcion: event.target.value })}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase rows={resultados} columns={columns} loading={cargando} />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default Access;
